var map = {
	"./ico-right-pride1.png": "YGXj",
	"./ico-right-pride2.png": "6yae",
	"./ico-right-pride3.png": "IXJp",
	"./ico-right-pride4.png": "cqct"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KwzW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center ^\.\/ico\-right\-pride.*\.png$
// module id = KwzW
// module chunks = 89